module.exports = __webpack_public_path__ + "static/media/img-03.c71adf11.jpg";